import message from "@/utils/globalMessage";
import React, {Component} from 'react';
import { Button, Drawer, Input, Space, Tooltip } from "antd";
import ResponsiveModal from "@components/ResponsiveModal";
import actions from "@redux/EditableTable/actions";
import {connect} from "react-redux";
import {FilterOutlined, ReloadOutlined} from "@ant-design/icons";

import _ from "lodash";
import appActions from "@redux/app/actions";
import FunctionalTestingDetail from "@containers/facility/Equipment/FunctionalTesting/FunctionalTestingDetail";
import TableCreateIcon from "@components/Table/TableCreateIcon";
import { withRouter } from '@/router/withRouter';
import { buildFacilityPath, getFacilityContext } from '@/utils/route-context';
import {
    FormTemplateOptionLabel,
    formTemplateOptionSearchText,
} from "@components/FormTemplateOptionLabel";
import { filterFormsByFormType } from "@/utils/filter-forms-by-form-type";
import { effectiveUiFormType } from "@/utils/form-type-generic-compat";
import Select from "@components/ResponsiveSelect";
import { hasActiveFilters } from "@components/Table/filterState";
import { FORM_TYPE_OPTIONS } from "@/constants/form-type-options";

class FunctionTestingPageHeader extends Component {

    constructor(props) {
        super(props);
        this.state = {
            options: [],
            value: [],
            filter_dates: [],
            isTemplateSelector: false,
            selectedFormType: null,
            selectedTemplateRecord: null,
            selectedTypeOption: [{
                key: '',
                value: '',
                label: 'Blank Template(Default)',
                record: ''
            }],
            tableRef: this.props.tableRef,
            selectedTemplate: null,
            type_options: [],
            templatesLoading: false,
            filterValues: null,
            globalSearch: "",
            isFilterSearchDrawerOpen: false,
            isMobileFilterSearchDrawerOpen: false,
        }
    }

    handleGlobalSearchChange = (event) => {
        const value = event.target.value;
        this.setState({
            globalSearch: value,
        });

        if (!value) {
            this.props.handleSelect(null);
        }
    }

    handleGlobalSearch = (value) => {
        const nextValue = value && value.trim() ? value.trim() : null;
        this.setState({
            globalSearch: nextValue || "",
        });
        this.props.handleSelect(nextValue);
    }

    handleRefresh = () => {
        this.props.handleFresh()
    }

    handleOpenNew = () => {
        this.setState({
            isTemplateSelector: true,
            selectedFormType: null,
            selectedTemplate: null,
            selectedTemplateRecord: null,
            type_options: [],
            templatesLoading: false,
        });
    }

    resetTemplateModal = () => {
        this.setState({
            isTemplateSelector: false,
            selectedFormType: null,
            selectedTemplate: null,
            selectedTemplateRecord: null,
            type_options: [],
            templatesLoading: false,
        })
    }

    onClose = () => {
        this.setState({
            isOpenNew: false
        })
    }

    handOnlineSave = async (key, row) => {
        let result = await this.props.createRecords(row);
        if (!(result?.response?.status > 299)) {
            this.setState({
                isOpenNew: false
            })
            this.props.handleFresh();
        }
    }

    formRefCallback = (formRef) => {
        this.props.getFormRef(formRef);
    }

    renderDrawer = () => {

        return (
            <>
                <Drawer
                    width={window.innerWidth > 900 ? '90%' : '100%'}
                    placement="right"
                    closable={false}
                    onClose={this.onClose}
                    visible={this.state.isOpenNew}
                    destroyOnClose={true}
                    autoFocus={true}
                >
                    <div>
                         <FunctionalTestingDetail
                                    selectedTemplateType={this.state.selectedTemplateType}
                                    selectedTypeOption={this.state.selectedTypeOption}
                                    selectedRecord={this.props.selectedRecord}
                                    handOnlineSave={this.handOnlineSave}
                                    columnProps={this.props.columnProps}
                                    formClassName={this.props.formClassName}
                                    isNewRecords={true}
                                    onClose={this.onClose}
                                    formRefCallback={this.formRefCallback}
                            />
                    </div>
                </Drawer>
            </>)
    }


    handleOpenFilters = () => {
        if (this.props.isPC === false) {
            this.setState({
                isMobileFilterSearchDrawerOpen: true
            })
            return;
        }

        this.setState({
            isFilterSearchDrawerOpen: true
        })
    }

    handleCloseFilterSearch = () => {
        this.setState({
            isFilterSearchDrawerOpen: false
        })
    }

    handleCloseMobileFilterSearch = () => {
        this.setState({
            isMobileFilterSearchDrawerOpen: false
        })
    }

    handleFilterChange = (filterValues, originalHandleFilter) => {
        this.setState({
            filterValues,
        });

        if (typeof originalHandleFilter === "function") {
            return originalHandleFilter(filterValues);
        }
    }

    handleResetFilters = () => {
        this.setState({
            filterValues: null,
            globalSearch: "",
        });

        this.props.handleSelect(null);

        if (typeof this.props.resetFilters === "function") {
            return this.props.resetFilters();
        }
    }

    enhanceFilterContent = (filterContent) => {
        if (Array.isArray(filterContent)) {
            return filterContent.map(this.enhanceFilterContent);
        }

        if (!React.isValidElement(filterContent)) {
            return filterContent;
        }

        const enhancedChildren = React.Children.map(
            filterContent.props?.children,
            this.enhanceFilterContent
        );

        const nextProps = enhancedChildren !== undefined ? { children: enhancedChildren } : {};
        const componentName =
            filterContent.type?.displayName ||
            filterContent.type?.name ||
            filterContent.type?.render?.displayName ||
            filterContent.type?.render?.name;
        const isFilterAwareElement =
            typeof filterContent.props?.handleFilter === "function" ||
            typeof filterContent.props?.onFilterValueChange === "function" ||
            typeof filterContent.props?.SelectedLookup_CommonRequest === "function" ||
            typeof filterContent.props?.Lookup_CommonupRequest === "function" ||
            typeof filterContent.props?.request === "function" ||
            ["SearchLookup", "AutoSearchSelect", "ResponsiveSelect"].includes(componentName);

        if (isFilterAwareElement) {
            nextProps.handleFilter = (filterValues) =>
                this.handleFilterChange(filterValues, filterContent.props.handleFilter);
            nextProps.onFilterValueChange = (filterValues) =>
                this.handleFilterChange(filterValues, filterContent.props.onFilterValueChange);
        }

        return React.cloneElement(filterContent, nextProps);
    }

    renderFilterContent = () => {
        if (typeof this.props.renderFilter === "undefined") {
            return "";
        }

        return this.enhanceFilterContent(this.props.renderFilter());
    }

    renderFilterArea = () => {
        if (typeof this.props.renderFilter === "undefined") {
            return "";
        }

        if (this.props.isPC === false) {
            return "";
        }

        return this.renderFilterContent();
    }

    renderFilterSearchFields = (isMobile) => {
        if (isMobile) {
            return this.renderMobileFilterSearchFields();
        }

        const fields = [];
        const shouldRenderGlobalSearch = this.props.hide_search === false;
        const hasRenderSearches = typeof this.props.renderSearches === "function";
        const hasRenderFilter = typeof this.props.renderFilter === "function";
        const isSameFilterRenderer =
            hasRenderSearches &&
            hasRenderFilter &&
            this.props.renderSearches === this.props.renderFilter;

        if (shouldRenderGlobalSearch) {
            fields.push(
                <div key="global-search" className="table-page-header-filter-drawer-field">
                    {this.renderGlobalSearchInput(true)}
                </div>
            );
        }

        if (hasRenderSearches) {
            fields.push(
                <div key="searches" className="table-page-header-filter-drawer-field">
                    {this.renderSearchContent()}
                </div>
            );
        }

        if (hasRenderFilter && !isSameFilterRenderer) {
            fields.push(
                <div key="filters" className="table-page-header-filter-drawer-field">
                    {this.renderFilterContent()}
                </div>
            );
        }

        return fields;
    }

    renderFilterSearchContent = (options = {}) => {
        const isMobile = this.props.isPC === false;
        const { showInlineReset = isMobile } = options;

        return (
            <div className="table-page-header-filter-search-content">
                {showInlineReset ? (
                    <div className="table-page-header-filter-search-reset-row">
                        <div></div>
                        <button className="table-page-header-filter-reset-link" onClick={this.handleResetFilters}>
                            Reset
                        </button>
                    </div>
                ) : null}
                <div className="table-page-header-filter-search-fields">
                    {this.renderFilterSearchFields(isMobile)}
                </div>
            </div>
        );
    }

    renderFilterSearchDrawer = () => {
        return (
            <Drawer
                placement="right"
                width={420}
                title="Filter and search"
                className="table-page-header-filter-drawer"
                visible={this.state.isFilterSearchDrawerOpen}
                onClose={this.handleCloseFilterSearch}
                destroyOnClose={false}
                footer={
                    <div className="table-page-header-filter-drawer-footer">
                        <Button onClick={this.handleResetFilters}>
                            Reset
                        </Button>
                    </div>
                }
            >
                <div className="table-page-header-filter-drawer-content">
                    {this.renderFilterSearchContent({ showInlineReset: false })}
                </div>
            </Drawer>
        );
    }

    renderMobileFilterSearchDrawer = () => {
        return (
            <Drawer
                placement="bottom"
                height="72vh"
                title="Filter and search"
                className="table-page-header-mobile-filter-drawer"
                visible={this.state.isMobileFilterSearchDrawerOpen}
                onClose={this.handleCloseMobileFilterSearch}
                destroyOnClose={false}
            >
                <div className="table-page-header-mobile-filter-content">
                    {this.renderFilterSearchContent()}
                </div>
            </Drawer>
        );
    }

    renderSearchContent = () => {
        if (typeof this.props.renderSearches === "function") {
            return this.enhanceFilterContent(this.props.renderSearches());
        }

        if (this.props.isPC !== false && typeof this.props.renderFilter === "function") {
            return this.enhanceFilterContent(this.props.renderFilter());
        }

        return "";
    }

    renderMobileFilterSearchFields = () => {
        const fields = [];
        const shouldRenderGlobalSearch = this.props.hide_search === false;
        const hasRenderSearches = typeof this.props.renderSearches === "function";
        const hasRenderFilter = typeof this.props.renderFilter === "function";
        const isSameFilterRenderer =
            hasRenderSearches &&
            hasRenderFilter &&
            this.props.renderSearches === this.props.renderFilter;

        if (shouldRenderGlobalSearch) {
            fields.push(
                <div key="global-search" className="mb-4 table-page-header-mobile-filter-field">
                    {this.renderGlobalSearchInput(true)}
                </div>
            );
        }

        if (hasRenderSearches) {
            fields.push(
                <div key="searches" className="mb-4 table-page-header-mobile-filter-field">
                    {this.renderSearchContent()}
                </div>
            );
        }

        if (hasRenderFilter && !isSameFilterRenderer) {
            fields.push(
                <div key="filters" className="mb-4 table-page-header-mobile-filter-field">
                    {this.renderFilterContent()}
                </div>
            );
        }

        return fields;
    }

    hasMobileFilterSearchContent = () =>
        this.props.hide_search === false ||
        typeof this.props.renderSearches === "function" ||
        typeof this.props.renderFilter === "function" ||
        typeof this.props.resetFilters !== "undefined";

    renderFilterSearchButton = (filterHasValue) => {
        if (
            this.props.isPC === false &&
            !this.hasMobileFilterSearchContent()
        ) {
            return null;
        }

        if (this.props.isPC !== false && typeof this.props.resetFilters === 'undefined') {
            return <div className={'ml-5 px-3'} />;
        }

        const button = (
            <Tooltip title="Filter and search">
                <Button
                    key="button4"
                    type="default"
                    shape="circle"
                    icon={
                        <FilterOutlined
                            className="table-page-header-filter-icon"
                        />
                    }
                    className={[
                        "table-page-header-icon-btn",
                        filterHasValue ? "table-page-header-icon-btn--filtered" : "",
                    ].filter(Boolean).join(" ")}
                    onClick={this.handleOpenFilters}
                    aria-label="Filter and search"
                />
            </Tooltip>
        );

        if (this.props.isPC === false) {
            return button;
        }

        return button;
    }

    renderGlobalSearch = () => {
        return this.renderGlobalSearchInput(false);
    }

    renderGlobalSearchInput = (isDrawer = false) => {
        if (this.props.hide_search !== false) {
            return null;
        }

        return (
            <Input.Search
                allowClear
                enterButton
                className="table-page-header-global-search"
                placeholder="Search"
                value={this.state.globalSearch}
                onChange={this.handleGlobalSearchChange}
                onSearch={this.handleGlobalSearch}
                style={{ width: isDrawer ? "100%" : this.props.isPC === false ? 180 : 260 }}
            />
        );
    }

    loadTemplatesForFormType = async (formType) => {
        if (!formType) {
            this.setState({ type_options: [], templatesLoading: false });
            return;
        }
        const equipment_type =
            this.props.selectedRecord?.equipment_category ??
            this.props.selectedRecord?.category;
        try {
            const response = await filterFormsByFormType({
                formType,
                equipmentType: equipment_type,
                companyId: this.props.companyId,
            });
            const type_data = response?.data?.results || [];
            const type_options = [{
                key: "",
                value: "",
                label: "Blank Template(Default)",
                searchText: formTemplateOptionSearchText(""),
                record: ""
            }];
            for (let i = 0; i < type_data.length; i++) {
                const row = type_data[i];
                type_options.push({
                    key: row.id,
                    value: row.id,
                    label: <FormTemplateOptionLabel row={row} />,
                    searchText: formTemplateOptionSearchText(row),
                    record: row
                });
            }
            this.setState({ type_options, templatesLoading: false });
        } catch (e) {
            console.error(e);
            const data = e?.response?.data;
            const serverMsg =
                (typeof data?.detail === "string" ? data.detail : null) ||
                (Array.isArray(data?.form_type) ? data.form_type.join(" ") : null) ||
                (typeof data === "string" ? data : null);
            message.error(
                serverMsg ? `Failed to load templates: ${serverMsg}` : "Failed to load templates"
            );
            this.setState({ type_options: [], templatesLoading: false });
        }
    }

    handleFormTypeSelect = async (value) => {
        this.setState({
            selectedFormType: value,
            selectedTemplate: null,
            selectedTemplateRecord: null,
            templatesLoading: true,
            type_options: [],
        });
        await this.loadTemplatesForFormType(value);
    }

    handleSearchSelect = (value, option) => {
        const hasRecord = option && option.record !== undefined && option.record !== "";
        const data = hasRecord ? option.record : null;
        this.setState({
            selectedTypeOption: data?.fields,
            selectedTemplate: value,
            selectedTemplateRecord: data,
            selectedTemplateType: data?.type ? data.type : "Generic",
        });
    };

    onTemplateSelectorNext = () => {
        const { selectedFormType, selectedTemplate, selectedTemplateRecord } = this.state;
        if (!selectedFormType) {
            message.warning("Please select a form type");
            return;
        }
        if (selectedTemplate === null || selectedTemplate === undefined) {
            message.warning("Please select a template");
            return;
        }

        // URL formType：空白用工具栏选择；选模板时用「有效类型」（兼容 generic 存为 functional_test + _fkpi_template_kind）
        const formTypeForUrl =
            selectedTemplate === "" || selectedTemplateRecord == null
                ? selectedFormType
                : (effectiveUiFormType(selectedTemplateRecord) ||
                    selectedTemplateRecord.form_type ||
                    selectedFormType);

        const equipment_type =
            this.props.selectedRecord?.equipment_category ??
            this.props.selectedRecord?.category;
        const templateCategory =
            equipment_type !== undefined && equipment_type !== null && `${equipment_type}`.trim() !== ""
                ? String(equipment_type)
                : undefined;

        if (this.props.navigate) {
            const targetPath = buildFacilityPath("create-functional-testing", {
                companyId: this.props.companyId,
                facilityId: this.props.facilityId,
                query: {
                    // 空白模板 value 为 ""，不能用 || undefined，否则创建页会再弹一次模板选择框
                    templateId:
                        selectedTemplate === "" || selectedTemplateRecord == null
                            ? "blank"
                            : selectedTemplate,
                    equipmentId: this.props.selectedRecord?.id || undefined,
                    formType: formTypeForUrl,
                    templateCategory,
                },
            }) || "/switch-view";
            this.props.navigate(targetPath);
            this.resetTemplateModal();
        } else {
            this.setState({
                isTemplateSelector: false,
                isOpenNew: true,
            });
        }
    }

    renderTemplateSelector = () => {
        const { selectedFormType, isTemplateSelector, templatesLoading } = this.state;

        return (
            <ResponsiveModal
                key="detailmodal"
                width={440}
                centered
                wrapClassName="functional-testing-template-modal"
                className="functional-testing-template-modal-inner"
                title="Select form type and template"
                onCancel={this.resetTemplateModal}
                closable={true}
                open={isTemplateSelector}
                footer={
                    <div className="functional-testing-template-modal-footer">
                        <Button
                            type="primary"
                            size="large"
                            block
                            className="functional-testing-template-next-btn"
                            onClick={this.onTemplateSelectorNext}
                            loading={templatesLoading}
                        >
                            Next
                        </Button>
                    </div>
                }
            >
                <div className="functional-testing-template-modal-body flex flex-col gap-4">
                    <div>
                        <label className="functional-testing-template-field-label" htmlFor="functional-testing-form-type-select">
                            Form type
                        </label>
                        <Select
                            id="functional-testing-form-type-select"
                            className="functional-testing-template-select"
                            style={{ width: "100%" }}
                            placeholder="Choose a form type"
                            value={selectedFormType != null ? selectedFormType : undefined}
                            onChange={this.handleFormTypeSelect}
                            options={FORM_TYPE_OPTIONS}
                            optionFilterProp="label"
                            disabled={templatesLoading}
                            getPopupContainer={(trigger) =>
                                trigger.parentElement || document.body
                            }
                        />
                    </div>
                    <div>
                        <label className="functional-testing-template-field-label" htmlFor="functional-testing-template-select">
                            Template
                        </label>
                        <Select
                            id="functional-testing-template-select"
                            className="functional-testing-template-select"
                            style={{ width: "100%" }}
                            placeholder={
                                selectedFormType
                                    ? "Choose a template to start from"
                                    : "Select a form type first"
                            }
                            value={this.state.selectedTemplate != null ? this.state.selectedTemplate : undefined}
                            onChange={this.handleSearchSelect}
                            options={this.state.type_options}
                            optionFilterProp="searchText"
                            showSearch
                            disabled={!selectedFormType || templatesLoading}
                            loading={templatesLoading}
                            getPopupContainer={(trigger) =>
                                trigger.parentElement || document.body
                            }
                        />
                    </div>
                </div>
            </ResponsiveModal>

        )
    }

    render() {
        const filterHasValue = hasActiveFilters(
            this.props.filterHasValue,
            this.props.filterValues,
            this.state.filterValues,
            this.props.filter_dates,
            this.props.filterDescription
        );

        return (

            <div className={this.props.endToolbarSlot ? ' table-page-header--root table-page-header--pro-toolbar-embedded -mx-3 items-center w-full' : ' table-page-header--root -mx-3 items-center w-full'}>
                <div className=" lg:w-auto flex items-center justify-between px-3">


                    <div>
                        {this.props.filterDescription}
                    </div>

                </div>
                <div className={this.props.endToolbarSlot ? 'table-page-header-toolbar-band max-w-full px-3 flex flex-nowrap items-center justify-start min-w-0' : 'table-page-header-toolbar-band max-w-full px-3 flex flex-nowrap items-center justify-start min-w-0 mt-2'}>


                    <div
                        className={[
                            "flex table-page-header-main-row table-page-header-main-row--split filter-item justify-between w-full min-w-0 items-center",
                            this.props.isPC === false ? "table-page-header-main-row--mobile-filter-icon-only" : "",
                        ].filter(Boolean).join(" ")}
                    >
                        <div className="table-page-header-filter-aux flex flex-nowrap items-center justify-start gap-3 min-w-0 flex-1">
                            {this.props.isPC === false ? null : this.renderGlobalSearch()}

                        </div>

                        {!this.props.isHideRefreshNews && <div className="flex items-center table-page-header-actions">
                            <Space size={8} align="center" wrap={false} className="table-page-header-icon-group">
                            <Tooltip title="Refresh list">
                                <Button
                                    key="button1"
                                    type="default"
                                    shape="circle"
                                    className="table-page-header-icon-btn reload-refresh-btn"
                                    icon={<ReloadOutlined />}
                                    onClick={this.handleRefresh}
                                    aria-label="Refresh list"
                                />
                            </Tooltip>

                            {!this.props.hid_new ? (
                                <Tooltip title="New form">
                                    <Button
                                        key="button2"
                                        type="default"
                                        shape="circle"
                                        className="table-page-header-icon-btn"
                                        icon={<TableCreateIcon />}
                                        onClick={this.handleOpenNew}
                                        aria-label="New form"
                                    />
                                </Tooltip>
                            ) : null}

                            {this.renderFilterSearchButton(filterHasValue)}
                            {this.props.endToolbarSlot ? (
                                <span className="table-page-header-end-slot flex items-center">
                                    {this.props.endToolbarSlot}
                                </span>
                            ) : null}
                            </Space>

                        </div>}

                    </div>

                </div>
                {this.state.isOpenNew ? this.renderDrawer() : ''}
                {this.state.isTemplateSelector ? this.renderTemplateSelector() : ''}
                {this.props.isPC === false && this.hasMobileFilterSearchContent()
                    ? this.renderMobileFilterSearchDrawer()
                    : null}
                {this.props.isPC !== false ? this.renderFilterSearchDrawer() : null}

            </div>

        );
    }
}

const mapStateToProps = state => {
    const role = _.get(state, 'Auth.role', {});
    const Role = role && Object.keys(role)[0];
    const facilityContext = getFacilityContext(state);
    const companyFromFacility = _.get(state, "Facility.selected.record.company_id");
    const companyId =
        facilityContext.companyId ||
        (companyFromFacility != null && companyFromFacility !== ""
            ? String(companyFromFacility)
            : null);
    return {
        Role: Role,
        companyId,
        facilityId: facilityContext.facilityId,
        isPC: state.App?.isPC,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        changeCurrent: (e) => dispatch(appActions.changeCurrent(e)),
        OpenDrawer: (e, id) => dispatch(actions.OpenDrawer(e, id))
    }
}

const ConnectedFunctionTestingPageHeader = withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(FunctionTestingPageHeader));



export default ConnectedFunctionTestingPageHeader;
